// extracted by mini-css-extract-plugin
export default {"wrapper":"src-modules-order-summary-order-summary-table-style__wrapper_XLLZ-","total":"src-modules-order-summary-order-summary-table-style__total_eFP0h"};